/* eslint-disable react/prop-types */
/* eslint-disable prefer-template */
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { Form, Label, Button, TextArea, Message } from 'semantic-ui-react';
import ModalWrapper from '../../common/modals/ModalWrapper';

import { cpgByComplaintId } from '../../../graphql/queries';
import { createComplaintCpg } from '../../../graphql/mutations';
import { closeModal } from '../../../redux/modals/modalReducer';

export function ModalComplaintCPG({ complaint }) {
  const dispatch = useDispatch();

  const userId = localStorage.getItem('userId');
  const userFirstname = localStorage.getItem('userFirstname');
  const userLastname = localStorage.getItem('userLastname');

  const [contentData, setContentData] = useState('');
  const [contentError, setContentError] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);

  const [addComplaintCpg] = useMutation(createComplaintCpg, {
    refetchQueries: [cpgByComplaintId],
    onError: (error) => {
      setErrorMessage("Une erreur technique s'est produite");
      console.error(error.message);
    }
  });

  const MAX_LENGHT = 250;
  const [characterCount, setCharacterCount] = useState(0);

  const handleContent = (event) => {
    setContentData(event.target.value);
    setCharacterCount(event.target.value.length);
    setContentError('');
  };
  const handleSubmit = () => {
    try {
      if (contentData === '') {
        setContentError('Une recommandée du CGP est requis pour continuer');
        return;
      }

      const payload = {
        complaintId: complaint.confirmation,
        content: contentData,
        // eslint-disable-next-line object-shorthand
        cognitoId: userId,
        profileName: userFirstname + ' ' + userLastname,
        createdAt: new Date().toISOString()
      };

      addComplaintCpg({
        variables: { input: payload }
      });

      dispatch(closeModal());
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalWrapper size="small" header="Ajouter une recommendation">
      {errorMessage && (
        <Message negative>
          <Message.Header>Erreur !!!</Message.Header>
          <p>Nous sommes désolés de ne pas pouvoir récuperer les informations</p>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Form size="large" className="attached fluid segment" onSubmit={handleSubmit}>
        <Form.Field>
          <TextArea
            maxLength={MAX_LENGHT}
            name="content"
            rows={3}
            value={contentData}
            onChange={handleContent}
          />
          Il vous reste:
          <Label circular color="green">
            {MAX_LENGHT - characterCount}
          </Label>
          {contentError && (
            <Label basic color="red" pointing>
              {contentError}
            </Label>
          )}
        </Form.Field>

        <Button fluid type="submit" positive content="Ajouter" />
      </Form>
    </ModalWrapper>
  );
}
export default ModalComplaintCPG;
